import { createStore, createEvent } from "effector";
import { UserStoreState } from "./UserStore.types";
import { userStoreState } from "./UserStore.consts";

// Eventos (ações)
export const setUser = createEvent<UserStoreState>('setUser');
export const setStation = createEvent<string>('setStation');
export const logout = createEvent();

// Store inicial
export const UserStore = createStore<UserStoreState>(userStoreState)
  .on(setUser, (_, payload) => payload)
  .on(setStation, (store, station) => ({...store, station}))
  .reset(logout);
